var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('upload-image',{attrs:{"name":_vm.name,"title":"Image principale","imgs":_vm.piscine.images,"saving":_vm.saving},on:{"imagesAdded":_vm.onImagesAdded,"onOrderChange":_vm.onOrderChange,"imageDeleted":_vm.onImageDeleted}})}
var staticRenderFns = []

export { render, staticRenderFns }